import { createStyles, makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => createStyles({
  formStylesRoot: {
    display: 'flex',
    flexFlow: 'column wrap',
    maxWidth: 300,
    width: '100%',
    marginBottom: 0
  },
  select: {
    width: '100%',
    maxWidth: 300
  },
  multipleSelect: {
    maxWidth: 300,
    width: '100%'
  },
  filledInput: {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  spacingBottom: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(2)
  }
}));
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  },
  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'center'
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'center'
  }
};